module.exports = __webpack_public_path__ + "static/p21-6ad5f0bed92bcaf1d8bcd5ef8e4ceb46.jpg";